// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.icon-show{
            display:flex;
            gap:10px;
            padding-top:7px;
        }
        collab-comp-img-generator{
            color:#3D3DB8;
            cursor:pointer;
        }

        `, "",{"version":3,"sources":["webpack://./src/app/shared/components/health-service-action-button-renderer.component.ts"],"names":[],"mappings":"AAAA;YACY,YAAY;YACZ,QAAQ;YACR,eAAe;QACnB;QACA;YACI,aAAa;YACb,cAAc;QAClB","sourcesContent":[".icon-show{\n            display:flex;\n            gap:10px;\n            padding-top:7px;\n        }\n        collab-comp-img-generator{\n            color:#3D3DB8;\n            cursor:pointer;\n        }\n\n        "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
